import React from "react";
import { Card, CardContent } from "../components/ui/Card";
import Sidebar from "../components/ui/Sidebar";
import "../style.css";

export default function Dashboard() {
  const userRole = sessionStorage.getItem("userRole") || "user"; // Get user role

  return (
    <div className="dashboard-container">
      <Sidebar userRole={userRole} />

      {/* Main Content */}
      <div className="dashboard-content">
        <h1 className="dashboard-header">Dashboard</h1>

        {/* Dashboard Grid Layout */}
        <div className="dashboard-grid">
          <div className="grid-row">
            <Card className="dashboard-card half-width">
              <CardContent>
                <h2>Sales/Donor Leads</h2>
                <p>Recent inquiries and potential donors.</p>
              </CardContent>
            </Card>

            <Card className="dashboard-card half-width">
              <CardContent>
                <h2>Upcoming Events</h2>
                <p>Next scheduled nonprofit activities.</p>
              </CardContent>
            </Card>
          </div>

          {/* Second Row: Full Width */}
          <Card className="dashboard-card full-width">
            <CardContent>
              <h2>Recent Revenue</h2>
              <p>Summary of donations and ticket sales.</p>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
}
